export enum PropertyListingCategory {
  ACTIVE = "active",
  INACTIVE = "inactive"
}
